import { useMemo } from 'react';

import { SidebarMenu, SidebarMenuItem } from 'components/ui/sidebar';

import { useSidebar } from '../context';
import { SidebarGroup, SidebarGroupLabel } from '../elements';
import { SideBarGroup } from '../types';

import { SidebarMenuItemComponent } from './SidebarItem';

interface SidebarGroupComponentProps {
  group: SideBarGroup;
}

export const SidebarGroupComponent = ({
  group
}: SidebarGroupComponentProps) => {
  const { collapsedGroups, toggleGroup } = useSidebar();

  const isCollapsed = collapsedGroups[group.title];
  const isCollapsable = group.isCollapsable !== false; // Default to true if not specified

  const handleGroupToggle = () => {
    if (isCollapsable) {
      toggleGroup(group.title);
    }
  };

  const menuItems = useMemo(() => group.items, [group.items]);

  return (
    <SidebarGroup>
      <SidebarGroupLabel
        onClick={handleGroupToggle}
        className={
          isCollapsable
            ? 'group cursor-pointer hover:text-indigo-700 hover:bg-neutral-50 rounded-md p-2 [&_i]:hover:text-indigo-700'
            : ''
        }
        isChevronIconVisible
        isCollapsed={
          !!collapsedGroups[group.title as keyof typeof collapsedGroups]
        }
      >
        {group.title}
      </SidebarGroupLabel>
      {!isCollapsed && (
        <SidebarMenu>
          {menuItems.map((item, index) => (
            <SidebarMenuItem key={`${item.title}-${index}`}>
              <SidebarMenuItemComponent item={item} groupTitle={group.title} />
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      )}
    </SidebarGroup>
  );
};
